if (!customElements.get("cart-quantity")) {
  class CartQuantity extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleChangeRef = this.handleChange.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      if (!event.target.hasAttribute("data-action")) return;

      this.updateQuantityViaLine(Number(this.querySelector("input").value) + 1 * event.target.getAttribute("data-action"));
    }

    handleChange(event) {
      if (event.target.value.length === 0 && !isNaN(+event.target.value)) return;

      this.updateQuantityViaLine(+event.target.value);
    }

    async getCurrentCartItems() {
      const response = await fetch('/cart.js', { method: "GET" });
      const cartJSON = await response.json();

      return cartJSON.items;
    }

    async updateQuantityViaLine(quantity) {
      /* Fix for item keys not working:
        Shopify API is currently disregarding item keys and only using the variant ID portion of the key
        This impacts updating items that may have the same variant ID, like bundle items
        In order to update bundle items correctly, we are using the array of numbers send to update.js
        This requires sending an array of quantities for every item in the cart
      */
      const cartItems = await this.getCurrentCartItems();

      // Create an array of current cart quantities
      const updates = cartItems.map((item) => item.quantity);

      // Update the item and connected (bundle) item quantities in the array
      const keys = this.getAttribute("data-keys").split(',');
      keys.forEach(key => {
        let keyIndex = cartItems.map((item) => item.key).indexOf(key);
        if (keyIndex > -1) {
          updates[keyIndex] = quantity;
        }
      });

      // Remove coolers if item was removed
      if (this.hasAttribute("data-coolers") && quantity === 0) {
        const coolers = this.dataset.coolers.split(',');

        coolers.forEach(cooler => {
          let keyIndex = cartItems.map((item) => item.variant_id).indexOf(cooler);
          if (keyIndex > -1) {
            updates[keyIndex] = 0;
          }
        });
      }

      // Remove warm weather variant if item was removed
      if (this.hasAttribute("data-warm-weather-variant") && quantity === 0) {
        let variantId = this.getAttribute("data-warm-weather-variant");
        let keyIndex = cartItems.map((item) => item.variant_id).indexOf(variantId);
        if (keyIndex > -1) {
          updates[keyIndex] = 0;
        }
      }

      // Standard update.js POST, same as in updateQuantity
      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    updateQuantity(quantity) {
      const updates = {};
      const keys = this.getAttribute("data-keys").split(',');

      keys.forEach(key => {
        updates[key] = quantity;
      });

      if (this.hasAttribute("data-coolers") && quantity === 0) {
        const coolers = this.dataset.coolers.split(',');

        coolers.forEach(cooler => updates[cooler] = 0);
      }

      if (this.hasAttribute("data-warm-weather-variant") && quantity === 0) {
        updates[`${this.getAttribute("data-warm-weather-variant")}`] = 0;
      }

      const body = JSON.stringify({
        updates,
        sections: `${this.getAttribute("data-section-id")}`,
      });

      fetch(window.routes.cart_update_url, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((responseText) => {
          dispatchCartEvent(
            JSON.parse(responseText).sections,
            this.getAttribute("data-section-id")
          );
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
      this.removeEventListener("change", this.handleChangeRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
      this.addEventListener("change", this.handleChangeRef);
    }
  }

  customElements.define("cart-quantity", CartQuantity);
}
